<template lang="pug">
	.files-window(v-if="showed && getPublisher()" :class="{'window-resizing': windowResizing}" v-window v-on:dragover="onManagerDragOver($event)" v-on:drop="onManagerDrop($event)")
		.card(:style="{width: windowWidth ? `${windowWidth}px` : '90vw', height: windowHeight ? `${windowHeight}px` : '70vh'}")
			.caption-area.card-header
				button.window-close(type="button" title="Close" @click="closeWindow()")
					i.fa.fa-times
				.caption {{sectionTitle()}}
				.storage-info(v-if="!isDocuments() && getStorage()")
					span.info-item Files: <b>{{formatSize(getStorage().used)}}</b> / <b>{{formatSize(getStorage().limit)}}</b>
					span.info-item Free: <b>{{formatSize(getStorage().free)}}</b>
					span.info-item(v-if="getStorage().serverFree !== null && getStorage().serverFree !== undefined") Server free: <b>{{formatSize(getStorage().serverFree)}}</b>
				.controls
					button.btn.btn-sm.btn-primary(type="button" @click="showNewFolder()" :disabled="!canCreateHere()")
						i.fa.fa-folder
						| &nbsp;&nbsp;New folder
					button.btn.btn-sm.btn-primary(type="button" @click="uploadFolder()" :disabled="!canCreateHere()")
						i.fa.fa-upload
						| &nbsp;&nbsp;Upload folder
					button.btn.btn-sm.btn-primary.gap(type="button" @click="upload()" :disabled="!canCreateHere()")
						i.fa.fa-upload
						| &nbsp;&nbsp;Upload files
					button.btn.btn-sm.btn-secondary.gap(type="button" @click="openLinks()")
						i.fa.fa-link
						| &nbsp;&nbsp;Public links
						span(v-if="links.length")  ({{links.length}})
					button.btn.btn-sm.btn-secondary(type="button" @click="refresh()")
						i.fa.fa-refresh
					button.btn.btn-sm.btn-secondary(type="button" @click="openSearch()")
						i.fa.fa-search
						| &nbsp;&nbsp;Search
					.two-pane-toggle
						span Two-pane
						label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
							input.switch-input.form-check-input(type="checkbox" :checked="twoPane" @change="setTwoPane($event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
							span.switch-handle
					button.btn.btn-sm.btn-secondary.log-button(v-if="isAdmin() && !isDocuments()" type="button" @click="openLog()")
						i.fa.fa-list-alt
						| &nbsp;&nbsp;Log
			.upload-progress(v-if="isUploading")
				.progress
					.progress-bar.progress-bar-striped.progress-bar-animated(:style="{width: (uploadProgress * 100) + '%'}")
			.error-message(v-if="errorMessage")
				span.message-text {{errorMessage}}
				button.error-close(type="button" title="Hide" @click="clearError()")
					i.fa.fa-times
			.panes(:class="{'two-pane': twoPane}")
				.pane(v-for="(pane, paneIndex) in panes" :class="{active: activePane === paneIndex, 'drop-target': isPaneDropTarget(paneIndex)}" @click="activePane = paneIndex" v-on:mousedown="onPaneMouseDown($event, paneIndex)" v-on:dragover="onPaneDragOver($event, paneIndex)" v-on:dragleave="onPaneDragLeave($event, paneIndex)" v-on:drop="onPaneDrop($event, paneIndex)")
					.breadcrumbs
						template(v-for="(parent, i) in getParents(paneIndex)")
							span.crumb(:key="'c' + parent.path" @click.stop="open(paneIndex, parent.path)") {{parent.name}}
							span.crumb-sep(:key="'s' + parent.path" v-if="i < getParents(paneIndex).length - 1") /
					.entries(v-if="getEntries(paneIndex).length || isInsideFolder(paneIndex)")
						.parent-entry(v-if="isInsideFolder(paneIndex)" title="Go up to the parent folder" :class="{'drop-target': isParentDropTarget(paneIndex)}" v-on:click="openParent(paneIndex)" v-on:dragover="onParentDragOver($event, paneIndex)" v-on:dragleave="onParentDragLeave($event, paneIndex)" v-on:drop="onParentDrop($event, paneIndex)")
							i.fa.fa-level-up
							span.parent-name ..
						.entry(v-for="entry in getEntries(paneIndex)" :key="entry.path" :class="{'drop-target': isEntryDropTarget(entry), selected: isEntrySelected(paneIndex, entry), cursor: isEntryCursor(paneIndex, entry)}" v-on:mousedown="onEntryMouseDown($event, paneIndex, entry)" v-on:mouseenter="onEntryMouseEnter(paneIndex, entry)" v-on:dblclick="onEntryDblClick(paneIndex, entry)" v-on:dragover="onEntryDragOver($event, paneIndex, entry)" v-on:dragleave="onEntryDragLeave($event, entry)" v-on:drop="onEntryDrop($event, paneIndex, entry)")
							.col.name(:class="{folder: entry.type === 'folder'}")
								i.fa.fa-arrows.entry-drag-handle(draggable="true" title="Drag to move" v-on:mousedown="onEntryDragHandleMouseDown($event)" v-on:dragstart="startEntryDrag($event, entry)" v-on:dragend="finishEntryDrag()")
								i.fa(:class="getEntryIcon(entry)")
								span.entry-name(:title="entry.name") {{entry.name}}
								i.fa.fa-history.versions-hint(v-if="entry.versions" :title="entry.versions === 1 ? '1 previous version' : `${entry.versions} previous versions`")
								.permissions(v-if="!isDocuments() && entry.permissions && entry.permissions.length")
									img.avatar(v-for="permissionUser in getEntryPermissions(entry)" :key="permissionUser.id" :src="permissionUser.photo" :title="getUserTitle(permissionUser)")
							.col.size {{formatSize(entry.size)}}
							.col.date {{formatDate(entry.date)}}
							.col.actions
								button.action(type="button" title="Rename" @click.stop="startRename(paneIndex, entry)")
									i.fa.fa-pencil
					.empty(v-if="!getEntries(paneIndex).length") This folder is empty
			// Действия с выделенными объектами: кнопки всегда внизу страницы, даже если файлов больше экрана
			.actions-bar
				.selection-info(v-if="selectedCount()") {{selectedCount()}} {{selectedCount() === 1 ? 'item' : 'items'}} selected
				.selection-info(v-else) Click a file to select it. Ctrl / Shift + click, mouse drag over rows or keyboard arrows select several files.
				.actions-buttons
					button.btn.btn-sm.btn-primary(type="button" :disabled="!selectedCount()" @click="downloadSelection()" title="Download selected files (folders as zip)")
						i.fa.fa-download
						| &nbsp;&nbsp;Download
					button.btn.btn-sm.btn-secondary(type="button" :disabled="!selectedCount()" @click="createLinksForSelection()" title="Create public links for selected items")
						i.fa.fa-external-link
						| &nbsp;&nbsp;Public link
					button.btn.btn-sm.btn-secondary(type="button" :disabled="!canEditSelection()" @click="editSelection()" :title="canEditSelection() ? 'Edit the selected text file' : 'Select one text file to edit'")
						i.fa.fa-pencil
						| &nbsp;&nbsp;Edit
					button.btn.btn-sm.btn-secondary(type="button" :disabled="!canShowVersions()" @click="openVersions()" :title="canShowVersions() ? 'Previous versions of the selected file' : 'Select one file with previous versions'")
						i.fa.fa-history
						| &nbsp;&nbsp;Versions
						span(v-if="canShowVersions()")  ({{getSingleSelectedEntry().versions}})
					button.btn.btn-sm.btn-secondary(type="button" :disabled="!canTransferSelection()" @click="copySelectionToOtherPane()" :title="twoPane ? 'Copy selected items to the other panel' : 'Turn on Two-pane mode to copy selected items'")
						i.fa.fa-copy
						| &nbsp;&nbsp;Copy
					button.btn.btn-sm.btn-secondary(type="button" :disabled="!canTransferSelection()" @click="moveSelectionToOtherPane()" :title="twoPane ? 'Move selected items to the other panel' : 'Turn on Two-pane mode to move selected items'")
						i.fa.fa-arrows
						| &nbsp;&nbsp;Move
					button.btn.btn-sm.btn-secondary(v-if="isSuperAdmin() && !isDocuments()" type="button" :disabled="!selectedCount()" @click="editPermissionsForSelection()" title="Access rights of selected items")
						i.fa.fa-users
						| &nbsp;&nbsp;Access rights
					button.btn.btn-sm.btn-danger(type="button" :disabled="!selectedCount()" @click="removeSelection()" title="Delete selected items")
						i.fa.fa-trash
						| &nbsp;&nbsp;Delete
			.resize-handle(title="Drag to resize" v-on:mousedown="startWindowResize($event)")
			.rename-overlay(v-if="renaming")
				.overlay-card
					label New name
					input.form-control(type="text" v-model="renaming.value" @keyup.enter="confirmRename()" @keyup.esc="renaming = null")
					.overlay-actions
						button.btn.btn-sm.btn-primary(type="button" @click="confirmRename()") Rename
						button.btn.btn-sm.btn-ghost-secondary(type="button" @click="renaming = null") Cancel
			.permissions-overlay(v-if="permissionsEditor")
				.overlay-card
					label Access to «{{permissionsEditor.title}}»
					.description(v-if="permissionsEditor.paths.length === 1") Only chosen users{{isSuperAdmin() ? ' (and super-admins)' : ''}} will see this {{permissionsEditor.entryType === 'folder' ? 'folder' : 'file'}}. Empty list = available to everyone.
					.description(v-else) Only chosen users{{isSuperAdmin() ? ' (and super-admins)' : ''}} will see the selected files and folders. Empty list = available to everyone. The list is applied to all selected items at once.
					.users-list
						.user-row(v-for="publisherUser in getPublisherUsers()" :key="publisherUser.id")
							label.form-check-label
								input.form-check-input(type="checkbox" :value="publisherUser.id" v-model="permissionsEditor.selected")
								img.avatar(:src="publisherUser.photo")
								span.user-name {{publisherUser.name}}
								span.user-activity (last activity: {{formatDate(publisherUser.last_activity_time)}})
					.overlay-actions
						button.btn.btn-sm.btn-primary(type="button" @click="confirmPermissions()") Save
						button.btn.btn-sm.btn-ghost-secondary(type="button" @click="permissionsEditor = null") Cancel
			.new-folder-overlay(v-if="newFolder")
				.overlay-card
					label New folder name
					input.form-control(type="text" ref="newFolderInput" v-model="newFolder.name" @keyup.enter="confirmCreateFolder()" @keyup.esc="newFolder = null")
					.overlay-actions
						button.btn.btn-sm.btn-primary(type="button" @click="confirmCreateFolder()") Create
						button.btn.btn-sm.btn-ghost-secondary(type="button" @click="newFolder = null") Cancel
			.key-overlay(v-if="isDocuments() && keyShowed")
				.overlay-card
					label Encryption key
					.description Enter the encryption key of the Documents section. Only a super-admin with the correct key can access these files. The key is not stored anywhere except in the current session.
					input.form-control(type="password" ref="keyInput" v-model="keyInput" @keyup.enter="submitKey()")
					.error-message(v-if="keyError") {{keyError}}
					.overlay-actions
						button.btn.btn-sm.btn-primary(type="button" @click="submitKey()") Unlock
						button.btn.btn-sm.btn-ghost-secondary(type="button" @click="closeKey()") Cancel
			.links-overlay(v-if="linksShowed")
				.overlay-card.links-card
					label Public links
					.description Anyone with the link can browse this folder or file (read only) and download the available files.
					.empty-links(v-if="!links.length") No public links created yet
					.existing-links-container(v-if="links.length")
						.existing-links
							.existing-link(v-for="link in links" :key="link.id")
								.link-date {{link.createDate.toLocaleString()}}
								.link-url
									a(:href="FileService.getLinkUrl(link)" target="_blank") {{link.hash}}
									span.link-path {{link.path}}
								.link-type {{link.type}}
								.link-actions
									button.action(type="button" title="Open in new tab" @click="openLink(link)")
										i.fa.fa-external-link
									button.action(type="button" title="Copy link" @click="copyLink(link)")
										i.fa.fa-files-o
									button.action.danger(type="button" title="Delete link" @click="removeLink(link)")
										i.fa.fa-trash
					.overlay-actions
						button.btn.btn-sm.btn-primary(type="button" @click="createLinkForActiveFolder()" :disabled="!canCreateHere()")
							i.fa.fa-plus
							| &nbsp;&nbsp;Create link for current folder
						button.btn.btn-sm.btn-dark(type="button" @click="linksShowed = false") Close

			.versions-overlay(v-if="versionsShowed")
				.overlay-card
					label Previous versions of «{{versionsEntry ? versionsEntry.entry.name : ''}}»
					.description The previous version and the current file are swapped when restored. Files up to {{formatSize(FileService.FILE_VERSION_SIZE_LIMIT)}} keep up to {{FileService.FILE_VERSION_MAX_COUNT}} previous versions.
					.versions-loading(v-if="versionsLoading") Loading previous versions...
					.empty-versions(v-else-if="!versions.length") No previous versions
					.versions-list(v-else)
						.version-row(v-for="version in versions" :key="version.id")
							.version-date {{formatDate(version.date)}}
							.version-size {{formatSize(version.size)}}
							.version-restore
								button.btn.btn-sm.btn-primary(type="button" @click="restoreVersion(version)") Restore
					.error-message.versions-error(v-if="versionsError") {{versionsError}}
					.overlay-actions
						button.btn.btn-sm.btn-dark(type="button" @click="closeVersions()") Close

			.search-overlay(v-if="searchShowed")
				.overlay-card.search-card
					label Search files and folders
					.description Finds files and folders by name in the whole section. Click a result to open the folder or preview the file.
					.search-input-row
						i.fa.fa-search
						input.form-control(type="text" ref="searchInput" placeholder="Enter a name..." v-model="searchQuery" @keyup.enter="runSearch()" @keyup.esc="closeSearch()")
						button.btn.btn-sm.btn-primary(type="button" @click="runSearch()" :disabled="!searchQuery") Search
					.search-loading(v-if="searchLoading") Searching...
					.error-message.search-error(v-else-if="searchError") {{searchError}}
					.empty-results(v-else-if="searchPerformed && !searchResults.length") Nothing found
					.search-results(v-if="searchResults.length")
						.search-result(v-for="entry in searchResults" :key="entry.path" @click="openSearchResult(entry)")
							i.fa(:class="getEntryIcon(entry)")
							.result-name(:title="entry.name") {{entry.name}}
							.result-path(:title="getSearchResultPath(entry)") {{getSearchResultPath(entry)}}
							.result-size {{entry.type === 'folder' ? '' : formatSize(entry.size)}}
							.result-date {{formatDate(entry.date)}}
					.overlay-actions
						button.btn.btn-sm.btn-dark(type="button" @click="closeSearch()") Close

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Publisher } 		from './../../services/Publisher'
	import { File as FileService } from './../../services/File'
	import { Server } 			from './../../services/Server'

	import { Notifications } from './../../services/Notifications'

	// MIME-тип полезной нагрузки перетаскивания файла / папки внутри менеджера.
	// По типу в dataTransfer менеджер понимает, что перетаскивается его объект, ещё до сброса (getData во время drag недоступен).
	const FILES_ENTRY_MIME_TYPE = 'application/x-mraidio-files-entry';

	export default {
		name: "File",
		// Раздел, который показывает компонент: 'files' (обычный файловый менеджер) или
		// 'documents' (защищённый раздел Documents, доступный только супер-админам с ключом шифрования).
		props: {
			section: {type: String, default: "files"}
		},
		mixins: [Screen],
		screen: {
			// Окно файлового менеджера обновляется при смене паблишера (открывается из аккаунт-меню)
			updateOn: ["Selected Publisher Changed"],
			events: {
				"File Changed": function() {
					// Объект могли удалить, перенести или переименовать - чистим выделение от пропавших путей
					this.pruneSelections();
					this.$forceUpdate();
				},
				// Результат операции. Для публичных ссылок показываем заметное подтверждение с адресом
				// (иначе создание/удаление ссылки никак не отражалось в интерфейсе), для остальных операций обновляем список
				"File Result": function(result) {
					// Результаты раздела Files и раздела Documents не должны смешиваться
					if ((result?.section === 'documents') !== this.isDocuments()) return;

					this.errorMessage = result?.error || '';
					// Публичная ссылка создана: собираем адреса и показываем их одним уведомлением.
					// Список ссылок придёт отдельным событием File Links Changed
					if (result?.operation === 'link-create' && !result?.error) {
						this.collectCreatedLink(FileService.getLinkUrl({hash: result.hash, section: result.section}));
					} else if (result?.operation === 'link-delete' && !result?.error) {
						Notifications.showSuccess('Public link deleted');
					} else if (result?.operation === 'restore-version') {
						// Предыдущая версия и текущий файл поменялись местами: обновляем список файлов,
						// а список версий придёт отдельным событием File Versions Changed
						if (!result?.error) Notifications.showSuccess('Previous version restored');
						this.refresh();
					} else {
						// Учитываем и неудачные результаты: иначе счётчик массовой операции не закроется
						this.applyBulkResult(result?.operation);
					}
					this.$forceUpdate();
				},
				// Список публичных ссылок паблишера
				"File Links Changed": function() {
					this.links = FileService.getLinks(this.publisherId());
					this.$forceUpdate();
				},
				// Список предыдущих версий открытого файла
				"File Versions Changed": function(state) {

					if (state?.error) {

						this.versionsError = state.error;
						this.versionsLoading = false;
						return;

					}

					// Пришли версии другого файла - окно версий их не показывает
					if (!this.versionsEntry || state?.path !== this.versionsEntry.entry.path) return;

					this.versions = FileService.getVersions(this.publisherId(), this.versionsEntry.entry.path);
					this.versionsError = '';
					this.versionsLoading = false;

					this.$forceUpdate();

				},
				// Результаты поиска по файлам и папкам раздела
				"File Search Changed": function(state) {

					// Результаты раздела Files и раздела Documents не должны смешиваться
					if ((state?.section === 'documents') !== this.isDocuments()) return;

					this.searchLoading = false;
					this.searchPerformed = true;

					if (state?.error) {

						this.searchError = state.error;
						this.searchResults = [];

					} else {

						this.searchError = '';
						this.searchResults = state?.entries || [];

					}

					this.$forceUpdate();

				},
				// Ответ на ввод ключа шифрования раздела Documents
				"Document Key Result": function(result) {
					if (!this.isDocuments()) return;

					this.keyLoading = false;

					if (result?.ok) {
						// Ключ верный: сервер сохранил его в объекте соединения, загружаем содержимое
						this.keyAccepted = true;
						this.keyShowed = false;
						this.keyError = '';
						FileService.requestLinks(this.publisherId());
						this.request(0);
						if (this.twoPane) this.request(1);
					} else {
						this.keyError = result?.error || 'Invalid encryption key';
					}
				},
				// Пользователи для иконок прав и редактора перерисовываем когда приходит их список
				"Server Data:Users": function() {
					this.$forceUpdate();
				}
			}
		},
		data() {

			this.FileService = FileService;

			// Текущий ресайз окна за угол (не нужно держать эти данные реактивными)
			this.resizeProcess = null;

			return {
				activePane: 0,
				leftPath: '',
				rightPath: '',
				twoPane: false,
				// Ключ шифрования раздела Documents: ввод и состояние проверки
				keyShowed: false,
				keyInput: '',
				keyError: '',
				keyAccepted: false,
				keyLoading: false,
				// Окно создания папки: {name}
				newFolder: null,
				// Окно публичных ссылок паблишера
				linksShowed: false,
				links: [],
				isUploading: false,
				uploadProgress: 0,
				errorMessage: '',
				// Поиск файлов и папок по имени во всём разделе: окно, строка, состояние и результаты
				searchShowed: false,
				searchQuery: '',
				searchLoading: false,
				searchError: '',
				searchResults: [],
				searchPerformed: false,
				renaming: null,
				// Редактор прав доступа: {paths, title, entryType, selected}
				permissionsEditor: null,
				// Выделенные объекты по панелям (массив путей), якорь shift-выделения и курсор клавиатуры
				selectedPaths: [[], []],
				selectionAnchors: [null, null],
				cursors: [null, null],
				// Идёт выделение протяжкой мыши: {paneIndex, basePaths}
				dragSelection: null,
				// Сколько ссылок ждём и их адреса (чтобы показать одно уведомление на массовое создание)
				linksCreation: null,
				// Массовая операция над выделением: {operation, pending} - список обновляем после последнего результата
				bulk: null,
				// Перетаскивание: индекс панели и путь папки под курсором (для подсветки цели сброса)
				dragOverPane: null,
				dragOverEntry: null,
				// Данные перетаскиваемого внутри менеджера файла / папки
				draggedEntry: null,
				// Предыдущие версии выбранного файла: {paneIndex, entry}
				versionsEntry: null,
				versionsShowed: false,
				versionsLoading: false,
				versions: [],
				versionsError: '',
				// Размер окна в пикселях: меняется драгом за угол и запоминается в localStorage
				windowWidth: 0,
				windowHeight: 0,
				windowResizing: false,
				// Панель, над точкой ".." которой перетаскивают объект (перенос на уровень вверх)
				dragOverParentPane: null
			}

		},
		computed: {
			// В однопанельном режиме второй панели нет вообще
			panes() {

				if (!this.twoPane) return [{path: this.leftPath}];

				return [{path: this.leftPath}, {path: this.rightPath}];

			}
		},
		methods: {
			// Текущий паблишер и признаки пользователя читаем методами, а не computed:
			// Publisher/User - не реактивные глобальные объекты, поэтому computed закешировал бы
			// их первое (возможно пустое) значение и страница осталась бы пустой.
			getPublisher() {

				// У защищённого раздела Documents нет паблишера, но окно должно открываться и без него
				if (this.isDocuments()) return {title: 'Documents'};

				return Publisher.SelectedPublisher;

			},
			isSuperAdmin() {

				return !!User.currentUser?.Tags?.['super-admin'];

			},
			isAdmin() {

				return !!User.currentUser?.isAdmin;

			},
			// Раздел Documents - защищённый раздел только для супер-админов с ключом шифрования
			isDocuments() {

				return this.section === 'documents';

			},
			// Заголовок окна: <паблишер> Files для обычного раздела и Documents для защищённого
			sectionTitle() {

				if (this.isDocuments()) return 'Documents';

				let publisher = this.getPublisher();

				return publisher ? `${publisher.title} Files` : 'Files';

			},
			getStorage() {

				return this.getState(0)?.storage || null;

			},
			canCreateHere() {

				return this.getState(this.activePane)?.canCreateRoot !== false;

			},
			getPublisherUsers() {

				// В разделе Documents управление правами не поддерживается
				if (this.isDocuments()) return [];

				return FileService.getPublisherUsers(this.publisherId());

			},
			// В состоянии с сервера permissions - это массив id пользователей
			getEntryPermissions(entry) {

				return _.map(entry.permissions || [], userId => {

					let permissionUser = User.getUser(userId) || {id: userId, name: `#${userId}`, last_activity_time: null};

					// Пользователь может быть без фото - подставляем иконку по-умолчанию, иначе аватар не отрисуется
					return _.extend({}, permissionUser, {photo: User.getPhotoUrl(permissionUser)});

				});

			},
			collectData(eventName) {

				// У раздела Documents нет паблишера, а у раздела Files он должен быть загружен
				if (!this.isDocuments() && !Publisher.SelectedPublisher) return;

				if (!this.isFilesAvailable()) {

					this.hide();
					return;

				}

				this.errorMessage = '';

				// Восстанавливаем режим панелей и размер окна из localStorage (пользователь уже загружен)
				this.restoreTwoPane();
				this.restoreWindowSize();

				// При открытии защищённого раздела запрашиваем у пользователя ключ шифрования
				if (this.isDocuments() && !this.keyAccepted) {

					this.keyShowed = true;
					this.keyInput = '';
					this.keyError = '';
					this.keyLoading = false;

					this.$nextTick(() => {
						if (this.$refs.keyInput) this.$refs.keyInput.focus();
					});

					return;

				}

				// Публичные ссылки запрашиваем сразу при открытии окна,
				// чтобы их количество было видно на кнопке "Public links"
				FileService.requestLinks(this.publisherId());

				this.request(0);
				if (this.twoPane) this.request(1);

			},
			// Отправляем введённый ключ шифрования на сервер: он проверит его по хэшу из конфига
			submitKey() {

				if (this.keyLoading) return;

				if (!this.keyInput) {

					this.keyError = 'Enter the encryption key';
					return;

				}

				this.keyLoading = true;
				this.keyError = '';

				Server.sendToServer({DocumentSetKey: {key: this.keyInput}});

			},
			closeKey() {

				this.keyShowed = false;
				this.keyInput = '';
				this.keyError = '';

				// Ключ не введён - защищённый раздел закрываем
				this.hide();

			},
			// Раздел Files доступен только для своего паблишера, а к чужим - только супер-админам.
			// Раздел Documents доступен только супер-админам (и только с ключом шифрования).
			isFilesAvailable() {

				if (!User.currentUser) return false;

				if (this.isDocuments()) return this.isSuperAdmin();

				if (!Publisher.SelectedPublisher) return false;
				if (this.isSuperAdmin()) return true;

				return Publisher.SelectedPublisher.id === User.currentUser['publisher_id'];

			},
			publisherId() {

				// У защищённого раздела Documents нет паблишера - используем 0 как признак раздела
				if (this.isDocuments()) return 0;

				return Publisher.SelectedPublisher?.id;

			},
			request(paneIndex) {

				FileService.request(this.publisherId(), this.panes[paneIndex].path);

			},
			refresh() {

				this.request(0);
				if (this.twoPane) this.request(1);

			},
			// ---- Поиск по файлам и папкам раздела ----

			// Открываем окно поиска и ставим курсор в поле ввода
			openSearch() {

				this.searchShowed = true;
				this.searchError = '';
				this.searchResults = [];
				this.searchPerformed = false;

				this.$nextTick(() => {

					if (this.$refs.searchInput) this.$refs.searchInput.focus();

				});

			},
			// Отправляем на сервер поиск по имени среди всех файлов и папок раздела
			runSearch() {

				let query = String(this.searchQuery || '').trim();

				if (!query) return;

				this.searchLoading = true;
				this.searchError = '';
				this.searchResults = [];
				this.searchPerformed = false;

				FileService.search(this.publisherId(), query);

			},
			// Закрываем окно поиска и сбрасываем его состояние
			closeSearch() {

				this.searchShowed = false;
				this.searchQuery = '';
				this.searchError = '';
				this.searchResults = [];
				this.searchLoading = false;
				this.searchPerformed = false;

			},
			// Переходим из результатов поиска к найденному объекту:
			// папку открываем в активной панели, а файл показываем в окне просмотра
			openSearchResult(entry) {

				if (!entry) return;

				if (entry.type === 'folder') this.open(this.activePane, entry.path);
				else {

					this.open(this.activePane, this.getParentPath(entry.path));
					this.openViewer(entry);

				}

				this.closeSearch();

			},
			// Папка, в которой лежит найденный объект (показываем её в результатах поиска)
			getSearchResultPath(entry) {

				return this.getParentPath(entry.path) || 'root';

			},
			getState(paneIndex) {

				return FileService.getState(this.publisherId(), this.panes[paneIndex]?.path || '');

			},
			getEntries(paneIndex) {

				return this.getState(paneIndex)?.entries || [];

			},
			getParents(paneIndex) {

				return this.getState(paneIndex)?.parents || [{name: 'root', path: ''}];

			},
			// Иконка строки списка: у папки и офисных документов своя, у остальных файлов - обычная
			getEntryIcon(entry) {

				if (!entry || entry.type === 'folder') return 'fa-folder';

				let kind = FileService.getPreviewKind(entry.path);

				if (kind === 'docx') return 'fa-file-word-o';
				if (kind === 'xlsx') return 'fa-file-excel-o';

				return 'fa-file-o';

			},
			// ---- Выделение объектов: клик, Ctrl / Shift + клик, протяжка мышью, клавиатура ----

			// Пути выделенных объектов в панели
			getSelectedPaths(paneIndex) {

				return this.selectedPaths[paneIndex] || [];

			},
			isEntrySelected(paneIndex, entry) {

				return _.includes(this.getSelectedPaths(paneIndex), entry.path);

			},
			// Курсор клавиатурной навигации - строка, с которой работают стрелки
			isEntryCursor(paneIndex, entry) {

				return this.cursors[paneIndex] === entry.path;

			},
			// Выделение присваиваем через $set: замена элемента массива по индексу сама по себе не реактивна
			setSelectedPaths(paneIndex, paths) {

				this.$set(this.selectedPaths, paneIndex, _.uniq(_.filter(paths, path => !!path)));

			},
			clearSelection(paneIndex) {

				this.setSelectedPaths(paneIndex, []);
				this.$set(this.selectionAnchors, paneIndex, null);
				this.$set(this.cursors, paneIndex, null);

			},
			// Выделяем один объект: 'plain' - только его, 'toggle' - добавить или убрать из выделения
			selectEntry(paneIndex, entry, mode = 'plain') {

				let paths = this.getSelectedPaths(paneIndex);

				if (mode === 'toggle') {

					paths = _.includes(paths, entry.path) ? _.without(paths, entry.path) : paths.concat([entry.path]);
					this.setSelectedPaths(paneIndex, paths);

				} else {

					this.setSelectedPaths(paneIndex, [entry.path]);

				}

				this.$set(this.cursors, paneIndex, entry.path);

			},
			// Выделяем интервал между двумя объектами (Shift + клик, Shift + стрелка, протяжка мышью)
			selectEntryRange(paneIndex, fromPath, toPath, basePaths = []) {

				let entries = this.getEntries(paneIndex);
				let fromIndex = _.findIndex(entries, entry => entry.path === fromPath);
				let toIndex = _.findIndex(entries, entry => entry.path === toPath);

				if (fromIndex === -1 || toIndex === -1) return;

				let start = Math.min(fromIndex, toIndex);
				let end = Math.max(fromIndex, toIndex);
				let rangePaths = _.map(_.slice(entries, start, end + 1), entry => entry.path);

				this.setSelectedPaths(paneIndex, basePaths.concat(rangePaths));

			},
			// Панель, объекты которой выделены: активная панель в приоритете,
			// иначе - панель, где осталось выделение (например после перехода во вторую панель)
			getSelectionPaneIndex() {

				if (this.getSelectedPaths(this.activePane).length) return this.activePane;

				let paneIndex = _.findIndex(this.selectedPaths, paths => paths && paths.length);

				return paneIndex === -1 ? this.activePane : paneIndex;

			},
			// Выделенные объекты панели - в том порядке, в котором они показаны
			getSelectedEntries() {

				let paneIndex = this.getSelectionPaneIndex();

				return _.filter(this.getEntries(paneIndex), entry => this.isEntrySelected(paneIndex, entry));

			},
			selectedCount() {

				return this.getSelectedEntries().length;

			},
			// Убираем из выделения пути, которых больше нет в панели (объект удалён, перенесён или переименован)
			pruneSelections() {

				_.each([0, 1], paneIndex => {

					let paths = this.getSelectedPaths(paneIndex);
					let entries = this.getEntries(paneIndex);

					if (paths.length) {

						let existingPaths = _.map(entries, entry => entry.path);
						let prunedPaths = _.filter(paths, path => _.includes(existingPaths, path));

						if (prunedPaths.length !== paths.length) this.setSelectedPaths(paneIndex, prunedPaths);

					}

					if (!_.some(entries, entry => entry.path === this.cursors[paneIndex])) this.$set(this.cursors, paneIndex, null);

				});

			},
			// Папка, в которой лежит объект ('a/b/c.txt' -> 'a/b')
			getParentPath(path) {

				return !path || path.indexOf('/') === -1 ? '' : path.substring(0, path.lastIndexOf('/'));

			},
			open(paneIndex, path) {

				if (paneIndex === 0) this.leftPath = path;
				else this.rightPath = path;

				// В другой папке прежнее выделение уже неактуально
				this.clearSelection(paneIndex);

				this.request(paneIndex);

			},
			setTwoPane(value) {

				this.twoPane = !!value;

				// При выключении двухпанельного режима активной снова становится первая панель,
				// а выделение во второй (скрытой) панели больше не актуально
				if (!this.twoPane) {

					this.activePane = 0;
					this.clearSelection(1);

				}

				if (User.currentUser) window.localStorage.setItem(`files-two-pane:${User.currentUser.id}`, this.twoPane ? '1' : '0');

				if (this.twoPane) this.request(1);

			},
			// Восстанавливаем включённый ранее двухпанельный режим из localStorage
			restoreTwoPane() {

				if (!User.currentUser) return;

				this.twoPane = window.localStorage.getItem(`files-two-pane:${User.currentUser.id}`) === '1';

				if (!this.twoPane) {

					this.activePane = 0;
					this.clearSelection(1);

				}

			},
			// Открываем окно создания папки (инпут рядом с кнопкой убран)
			showNewFolder() {

				this.newFolder = {name: ''};

				this.$nextTick(() => this.$refs.newFolderInput && this.$refs.newFolderInput.focus());

			},
			confirmCreateFolder() {

				let name = ((this.newFolder && this.newFolder.name) || '').trim();

				if (!name) return;

				FileService.createFolder(this.publisherId(), this.getActivePath(), name);

				this.newFolder = null;

			},
			// Путь активной панели (для создания папки и загрузки)
			getActivePath() {

				return this.panes[this.activePane]?.path || this.panes[0]?.path || "";

			},
			upload() {

				let input = document.createElement('input');

				input.type = 'file';
				input.multiple = true;
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.addEventListener('change', e => {

					let files = _.values(e.target.files);

					document.body.removeChild(input);

					this.uploadFiles(files, this.getActivePath());

				});

				input.click();

			},
			// Выбор папки для загрузки - только по нажатию кнопки (не по клику на название папки).
			// Папка проверяется на размер без сжатия (не больше 100 МБ) и упаковывается в zip.
			uploadFolder() {

				let input = document.createElement('input');

				input.type = 'file';
				input.webkitdirectory = true;
				input.multiple = true;
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.addEventListener('change', e => {

					let files = _.values(e.target.files);

					document.body.removeChild(input);

					this.uploadFolderFiles(files, this.getActivePath());

				});

				input.click();

			},
			uploadFolderFiles(files, path) {

				files = _.values(files || []).filter(file => !!file);

				if (!files.length || this.isUploading) return;

				this.isUploading = true;
				this.uploadProgress = 0;
				this.errorMessage = '';

				FileService.uploadFolder(this.publisherId(), path, files, progress => {

					this.uploadProgress = progress;

				}, error => {

					this.isUploading = false;
					this.errorMessage = error || '';

					this.refresh();

				});

			},
			// Загрузка файлов в папку: выбранных в диалоге или перетащенных из файловой системы
			uploadFiles(files, path) {

				files = _.values(files || []).filter(file => !!file);

				if (!files.length || this.isUploading) return;

				this.isUploading = true;
				this.uploadProgress = 0;
				this.errorMessage = '';

				FileService.upload(this.publisherId(), path, files, progress => {

					this.uploadProgress = progress;

				}, error => {

					this.isUploading = false;
					this.errorMessage = error || '';

					this.refresh();

				});

			},
			// --- Перетаскивание: файлы из файловой системы и перенос файлов / папок между панелями ---
			// ---- Мышь: выделение кликом, Ctrl / Shift + клик и протяжкой по строкам ----

			// Нажатие на строку: выделяем объект. Скачивание и открытие папки выполняются другими действиями
			onEntryMouseDown(event, paneIndex, entry) {

				if (event.button !== 0) return;

				// Кнопка переименования в строке и ручка перетаскивания работают сами по себе
				if (event.target.closest && (event.target.closest('button') || event.target.closest('.entry-drag-handle'))) return;

				this.activePane = paneIndex;

				let additive = !!(event.ctrlKey || event.metaKey);

				// Без Ctrl выделение возможно только в одной панели - вторую панель сбрасываем
				if (!additive) this.clearOtherPanesSelection(paneIndex);

				let basePaths = additive ? this.getSelectedPaths(paneIndex).slice() : [];

				// Пока кнопка мыши зажата, объекты под курсором продолжают расширять выделение
				this.dragSelection = {paneIndex, basePaths};

				if (event.shiftKey) {

					// Shift выделяет интервал от прошлого выделенного объекта (якоря)
					let anchorPath = this.selectionAnchors[paneIndex] || entry.path;

					this.$set(this.selectionAnchors, paneIndex, anchorPath);
					this.selectEntryRange(paneIndex, anchorPath, entry.path, basePaths);
					this.$set(this.cursors, paneIndex, entry.path);

				} else if (this.isOnlySelectedEntry(paneIndex, entry)) {

					// Повторное нажатие по единственному выделенному объекту снимает выделение
					this.clearSelection(paneIndex);
					this.$set(this.selectionAnchors, paneIndex, entry.path);

				} else {

					this.selectEntry(paneIndex, entry, additive ? 'toggle' : 'plain');
					this.$set(this.selectionAnchors, paneIndex, entry.path);

				}

				// Гасим выделение текста браузером, иначе протяжка выделяет текст, а не строки
				event.preventDefault();

				this.startDragSelectionListen();

			},
			// Нажатие на пустом месте панели: снимаем выделение, но протяжка с пустого места тоже работает
			onPaneMouseDown(event, paneIndex) {

				if (event.button !== 0) return;

				let target = event.target;

				if (!target || !target.closest) return;

				// Строки, кнопки и хлебные крошки обрабатывают нажатие сами
				if (target.closest('.entry') || target.closest('button') || target.closest('.breadcrumbs')) return;

				this.activePane = paneIndex;

				if (!event.ctrlKey && !event.metaKey) {

					// Без Ctrl выделение возможно только в одной панели
					this.clearOtherPanesSelection(paneIndex);

					if (!event.shiftKey) this.clearSelection(paneIndex);

				}

				this.dragSelection = {paneIndex, basePaths: this.getSelectedPaths(paneIndex).slice()};

				this.startDragSelectionListen();

			},
			// Протяжка мышью: объект под курсором продолжает интервал от якоря
			onEntryMouseEnter(paneIndex, entry) {

				if (!this.dragSelection || this.dragSelection.paneIndex !== paneIndex) return;

				this.$set(this.cursors, paneIndex, entry.path);

				let anchorPath = this.selectionAnchors[paneIndex];

				if (!anchorPath) {

					// Протяжка началась с пустого места панели - началом интервала становится первый объект под курсором
					anchorPath = entry.path;
					this.$set(this.selectionAnchors, paneIndex, anchorPath);

				}

				this.selectEntryRange(paneIndex, anchorPath, entry.path, this.dragSelection.basePaths);

			},
			// Что перетаскивается: файлы из ОС ('files'), объект внутри менеджера ('entry') или ничего
			getDragKind(event) {

				if (!event || !event.dataTransfer) return null;

				let types = Array.from(event.dataTransfer.types || []);

				if (_.includes(types, FILES_ENTRY_MIME_TYPE)) return 'entry';
				if (_.includes(types, 'Files')) return 'files';

				return null;

			},
			isPaneDropTarget(paneIndex) {

				return this.dragOverPane === paneIndex && !this.dragOverEntry;

			},
			isEntryDropTarget(entry) {

				return this.dragOverEntry === entry.path;

			},
			// Сброс подсветки цели сброса
			resetDragState() {

				this.dragOverPane = null;
				this.dragOverEntry = null;
				this.dragOverParentPane = null;

			},
			// Панель принимает файлы ОС (копирование) и объекты менеджера (перенос)
			onPaneDragOver(event, paneIndex) {

				let kind = this.getDragKind(event);

				if (!kind) return;

				// Без preventDefault браузер не разрешит сброс
				event.preventDefault();

				event.dataTransfer.dropEffect = kind === 'files' ? 'copy' : 'move';

				this.dragOverPane = paneIndex;
				this.dragOverEntry = null;

			},
			onPaneDragLeave(event, paneIndex) {

				// Уходим только когда курсор покинул панель, а не перешёл на её дочерний элемент
				if (event.currentTarget && event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) return;

				if (this.dragOverPane === paneIndex) this.resetDragState();

			},
			onPaneDrop(event, paneIndex) {

				let kind = this.getDragKind(event);

				if (!kind) return;

				event.preventDefault();

				let path = this.panes[paneIndex] ? this.panes[paneIndex].path : '';

				this.resetDragState();

				if (kind === 'files') this.handleFilesDrop(event.dataTransfer.files, path);
				else this.handleEntryDrop(path);

			},
			// Папки внутри панели - тоже цели сброса (перенос внутрь папки), остальные объекты не перехватывают событие
			onEntryDragOver(event, paneIndex, entry) {

				if (entry.type !== 'folder') return;

				let kind = this.getDragKind(event);

				if (!kind) return;

				event.preventDefault();
				// Не даём событию дойти до панели - иначе подсветятся и папка, и панель
				event.stopPropagation();

				event.dataTransfer.dropEffect = kind === 'files' ? 'copy' : 'move';

				this.dragOverPane = paneIndex;
				this.dragOverEntry = entry.path;

			},
			onEntryDragLeave(event, entry) {

				if (entry.type !== 'folder') return;

				event.stopPropagation();

				if (event.currentTarget && event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) return;

				if (this.dragOverEntry === entry.path) this.dragOverEntry = null;

			},
			onEntryDrop(event, paneIndex, entry) {

				if (entry.type !== 'folder') return;

				let kind = this.getDragKind(event);

				if (!kind) return;

				event.preventDefault();
				event.stopPropagation();

				this.resetDragState();

				if (kind === 'files') this.handleFilesDrop(event.dataTransfer.files, entry.path);
				else this.handleEntryDrop(entry.path);

			},
			// Корень страницы перехватывает сброс вне панелей, чтобы браузер не открыл перетащенный файл
			onManagerDragOver(event) {

				if (!this.getDragKind(event)) return;

				event.preventDefault();

			},
			onManagerDrop(event) {

				if (!this.getDragKind(event)) return;

				event.preventDefault();

				this.resetDragState();

			},
			startEntryDrag(event, entry) {

				this.draggedEntry = {path: entry.path, type: entry.type, name: entry.name};

				if (!event.dataTransfer) return;

				// Тянем строку за иконку-ручку, но картинкой перетаскивания показываем всю строку
				let row = event.currentTarget && event.currentTarget.closest ? event.currentTarget.closest('.entry') : null;

				if (row && event.dataTransfer.setDragImage) {

					try {

						event.dataTransfer.setDragImage(row, 20, 10);

					} catch (e) {}

				}

				try {

					event.dataTransfer.setData(FILES_ENTRY_MIME_TYPE, JSON.stringify(this.draggedEntry));

				} catch (e) {}

				// Без текстовых данных часть браузеров не разрешает перетаскивание (курсор "запрещено")
				event.dataTransfer.setData('text/plain', entry.name);
				event.dataTransfer.effectAllowed = 'move';

			},
			finishEntryDrag() {

				this.draggedEntry = null;

				this.resetDragState();

			},
			// Протяжку слушаем на документе: кнопку мыши можно отпустить где угодно
			startDragSelectionListen() {

				document.addEventListener('mouseup', this.onDocumentMouseUp);

			},
			onDocumentMouseUp() {

				this.dragSelection = null;

				document.removeEventListener('mouseup', this.onDocumentMouseUp);

			},
			// Двойной клик по папке открывает её, по файлу - показывает файл в отдельном окне
			onEntryDblClick(paneIndex, entry) {

				if (entry.type === 'folder') {

					this.open(paneIndex, entry.path);
					return;

				}

				this.openViewer(entry);

			},
			// Нажатие на ручку перетаскивания не должно начинать выделение протяжкой
			onEntryDragHandleMouseDown(event) {

				event.stopPropagation();

			},
			// Файлы, сброшенные из файловой системы, загружаем в папку-цель
			handleFilesDrop(fileList, path) {

				let files = _.values(fileList || []).filter(file => !!file);

				if (!files.length) return;

				this.uploadFiles(files, path);

			},
			// Объект менеджера (файл / папку), сброшенный на панель или папку, переносим в папку-цель
			handleEntryDrop(targetPath) {

				if (!this.draggedEntry) return;

				this.moveEntryTo(this.draggedEntry.path, this.draggedEntry.type, targetPath);

			},
			moveEntryTo(sourcePath, sourceType, targetFolderPath) {

				sourcePath = sourcePath || '';
				targetFolderPath = targetFolderPath || '';

				if (!sourcePath) return;

				// Нельзя переносить папку в саму себя или в свою подпапку
				if (sourceType === 'folder' && (targetFolderPath === sourcePath || targetFolderPath.indexOf(sourcePath + '/') === 0)) {

					this.errorMessage = `Cannot move «${sourcePath}» into itself`;
					return;

				}

				let sourceParent = this.getParentPath(sourcePath);

				// Объект уже лежит в этой папке - переносить нечего
				if (sourceParent === targetFolderPath) return;

				this.errorMessage = '';

				FileService.move(this.publisherId(), sourcePath, targetFolderPath);

			},
			// ---- Действия с выделенными объектами (кнопки внизу страницы) ----

			// Скачивание выделенных объектов: файлы - как есть, папки - одним zip-архивом
			downloadSelection() {

				let entries = this.getSelectedEntries();

				if (!entries.length) return;

				let oversized = [];

				_.each(entries, entry => {

					if (entry.type === 'file') {

						FileService.download(this.publisherId(), entry.path);
						return;

					}

					// Папка без сжатия должна укладываться в лимит zip-скачивания
					if ((entry.size || 0) > FileService.FOLDER_DOWNLOAD_SIZE_LIMIT) {

						oversized.push(`${entry.name} (${this.formatSize(entry.size)})`);
						return;

					}

					FileService.downloadFolder(this.publisherId(), entry.path);

				});

				this.errorMessage = oversized.length
					? `Folder must be smaller than ${this.formatSize(FileService.FOLDER_DOWNLOAD_SIZE_LIMIT)} without compression to be downloaded as zip: ${oversized.join(', ')}`
					: '';

			},
			// Создаём публичные ссылки на выделенные объекты: адреса соберём и покажем одним уведомлением
			createLinksForSelection() {

				let entries = this.getSelectedEntries();

				if (!entries.length) return;

				this.linksCreation = {pending: entries.length, urls: []};

				_.each(entries, entry => FileService.createLink(this.publisherId(), entry.path));

			},
			// Копирование / перенос выделенных объектов во вторую панель
			copySelectionToOtherPane() {

				this.transferSelection('copy');

			},
			moveSelectionToOtherPane() {

				this.transferSelection('move');

			},
			// Копирование и перенос возможны, только когда есть вторая панель - цель операции
			canTransferSelection() {

				return this.twoPane && this.selectedCount() > 0;

			},
			transferSelection(operation) {

				if (!this.canTransferSelection()) return;

				let paneIndex = this.getSelectionPaneIndex();
				let targetPath = this.panes[this.getOtherPaneIndex(paneIndex)]?.path || '';
				let result = this.filterTransferableEntries(this.getSelectedEntries(), targetPath);

				if (result.error) {

					this.errorMessage = result.error;
					return;

				}

				if (!result.items.length) {

					this.errorMessage = `Nothing to ${operation}: selected objects are already in «${targetPath || 'root'}»`;
					return;

				}

				this.errorMessage = '';
				this.startBulk(operation, result.items.length);

				_.each(result.items, entry => {

					if (operation === 'copy') FileService.copy(this.publisherId(), entry.path, targetPath);
					else FileService.move(this.publisherId(), entry.path, targetPath);

				});

			},
			// Отбрасываем объекты, которые уже лежат в целевой папке, и проверяем перенос папки в саму себя
			filterTransferableEntries(entries, targetFolderPath) {

				let items = [], error = '';

				_.each(entries, entry => {

					if (entry.type === 'folder' && (targetFolderPath === entry.path || targetFolderPath.indexOf(entry.path + '/') === 0)) {

						error = `Cannot copy or move «${entry.path}» into itself`;
						return;

					}

					if (this.getParentPath(entry.path) === targetFolderPath) return;

					items.push(entry);

				});

				return {items, error};

			},
			getOtherPaneIndex(paneIndex) {

				return paneIndex === 0 ? 1 : 0;

			},
			// Назначаем права выделенным объектам: галочки показываем у пользователей,
			// у которых доступ есть ко всем выделенным объектам
			editPermissionsForSelection() {

				let entries = this.getSelectedEntries();

				if (!entries.length) return;

				let selected = (entries[0].permissions || []).slice();

				_.each(entries, entry => {

					selected = _.filter(selected, userId => _.includes(entry.permissions || [], userId));

				});

				this.permissionsEditor = {
					paneIndex: this.getSelectionPaneIndex(),
					paths: _.map(entries, entry => entry.path),
					title: entries.length === 1 ? entries[0].name : `${entries.length} selected items`,
					entryType: entries.length === 1 ? entries[0].type : null,
					selected
				};

			},
			// Применяем выбранный список прав ко всем выделенным объектам
			confirmPermissions() {

				if (!this.permissionsEditor) return;

				let paths = this.permissionsEditor.paths || [];
				let userIds = this.permissionsEditor.selected || [];

				this.permissionsEditor = null;

				if (!paths.length) return;

				this.startBulk('permissions', paths.length);

				_.each(paths, path => FileService.setPermissions(this.publisherId(), path, userIds));

			},
			// Удаление выделенных объектов: одно подтверждение на всю операцию
			removeSelection() {

				let entries = this.getSelectedEntries();

				if (!entries.length) return;

				let question = entries.length === 1 ? `Delete "${entries[0].name}"?` : `Delete ${entries.length} selected items?`;

				if (!confirm(question)) return;

				this.errorMessage = '';
				this.startBulk('delete', entries.length);

				_.each(entries, entry => FileService.remove(this.publisherId(), entry.path));

			},
			// Массовая операция: результат придёт по одному на каждый объект - список обновим после последнего
			startBulk(operation, count) {

				this.bulk = {operation, pending: count};

			},
			applyBulkResult(operation) {

				if (this.bulk && this.bulk.pending > 0) {

					// Пришёл результат другой операции - счётчик массовой операции не трогаем
					if (this.bulk.operation !== operation) {

						this.refresh();
						return;

					}

					this.bulk.pending--;

					if (this.bulk.pending > 0) return;

					this.bulk = null;

				}

				this.refresh();

			},
			// Собираем адреса созданных ссылок: для массового создания показываем одно уведомление в конце
			collectCreatedLink(url) {

				if (!this.linksCreation) this.linksCreation = {pending: 1, urls: []};

				this.linksCreation.urls.push(url);
				this.linksCreation.pending--;

				if (this.linksCreation.pending > 0) return;

				let urls = this.linksCreation.urls;

				this.linksCreation = null;

				this.notifyLinksCreated(urls);

			},
			notifyLinksCreated(urls) {

				if (!urls.length) return;

				if (urls.length > 1) {

					Notifications.showSuccess(`${urls.length} public links created`);
					return;

				}

				// Копирование может быть недоступно браузером вне пользовательского действия - тогда просто показываем адрес
				Notifications.showSuccess(this.copyToClipboard(urls[0])
					? `Public link created and copied to clipboard: ${urls[0]}`
					: `Public link created: ${urls[0]}`);

			},
			// ---- Клавиатура: стрелки вверх / вниз, Shift и Ctrl для выделения, Ctrl + A - выделить всё ----

			onDocumentKeyDown(event) {

				if (!this.showed) return;

				// Оверлеи (переименование, права, ссылки, поиск, новая папка) перехватывают клавиатуру
				if (this.renaming || this.newFolder || this.permissionsEditor || this.linksShowed || this.versionsShowed || this.searchShowed) return;

				let target = event.target;

				if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT' || target.isContentEditable)) return;

				let paneIndex = this.activePane;
				let entries = this.getEntries(paneIndex);

				if (!entries.length) return;

				// Ctrl + A - выделяем все объекты панели
				if ((event.ctrlKey || event.metaKey) && (event.key === 'a' || event.key === 'A')) {

					event.preventDefault();
					this.$set(this.selectionAnchors, paneIndex, entries[0].path);
					this.$set(this.cursors, paneIndex, entries[0].path);
					this.setSelectedPaths(paneIndex, _.map(entries, entry => entry.path));

					return;

				}

				if (event.key === 'Escape') {

					this.clearSelection(paneIndex);
					return;

				}

				if (event.key === 'Enter') {

					// Enter открывает папку, на которой стоит курсор
					let cursorEntry = _.find(entries, entry => entry.path === this.cursors[paneIndex]);

					if (!cursorEntry || cursorEntry.type !== 'folder') return;

					event.preventDefault();
					this.open(paneIndex, cursorEntry.path);

					return;

				}

				let delta = event.key === 'ArrowDown' ? 1 : (event.key === 'ArrowUp' ? -1 : 0);

				if (!delta) return;

				event.preventDefault();

				let cursorIndex = _.findIndex(entries, entry => entry.path === this.cursors[paneIndex]);
				let index = cursorIndex === -1
					? (delta > 0 ? 0 : entries.length - 1)
					: Math.min(Math.max(cursorIndex + delta, 0), entries.length - 1);
				let entry = entries[index];

				if (cursorIndex === -1) {

					// Курсора ещё нет - стрелка просто выделяет первый / последний объект
					if (!event.ctrlKey && !event.metaKey) this.clearOtherPanesSelection(paneIndex);
					this.selectEntry(paneIndex, entry, 'plain');
					this.$set(this.selectionAnchors, paneIndex, entry.path);
					this.scrollCursorIntoView(paneIndex, index);

					return;

				}

				this.$set(this.cursors, paneIndex, entry.path);

				if (event.shiftKey) {

					// Shift + стрелка расширяет выделение от якоря (без Ctrl это тоже выделение в одной панели)
					this.clearOtherPanesSelection(paneIndex);
					this.selectEntryRange(paneIndex, this.selectionAnchors[paneIndex] || entry.path, entry.path);

				} else if (event.ctrlKey || event.metaKey) {

					// Ctrl + стрелка двигает курсор, не меняя выделение (чтобы не потерять выделенные объекты)

				} else {

					// Без Ctrl выделение возможно только в одной панели
					this.clearOtherPanesSelection(paneIndex);
					this.selectEntry(paneIndex, entry, 'plain');
					this.$set(this.selectionAnchors, paneIndex, entry.path);

				}

				this.scrollCursorIntoView(paneIndex, index);

			},
			// Курсор клавиатуры всегда должен быть виден: список бывает длиннее экрана
			scrollCursorIntoView(paneIndex, index) {

				this.$nextTick(() => {

					let pane = (this.$el.querySelectorAll('.pane') || [])[paneIndex];

					if (!pane) return;

					let row = (pane.querySelectorAll('.entries .entry') || [])[index];

					if (row && row.scrollIntoView) row.scrollIntoView({block: 'nearest'});

				});

			},
			startRename(paneIndex, entry) {

				this.renaming = {paneIndex, entry, value: entry.name};

			},
			confirmRename() {

				if (!this.renaming) return;

				FileService.rename(this.publisherId(), this.renaming.entry.path, this.renaming.value);

				this.renaming = null;

			},
			getUserTitle(user) {

				return `${user.name} — last activity: ${this.formatDate(user.last_activity_time)}`;

			},
			openLog() {

				// Лог файловых операций - отдельная страница: окно файлов перед этим закрываем
				this.hide();

				Layout.setPage('files-log', {backPage: ['playables', {}]});

			},
			// Единственный выделенный объект (или null) - для действий с одним файлом
			getSingleSelectedEntry() {

				let entries = this.getSelectedEntries();

				return entries.length === 1 ? entries[0] : null;

			},
			// Редактировать можно только один выделенный текстовый файл
			canEditSelection() {

				let entry = this.getSingleSelectedEntry();

				return !!entry && entry.type === 'file' && FileService.isTextFile(entry.path);

			},
			// Список версий показываем для одного файла, у которого есть сохранённые версии
			canShowVersions() {

				let entry = this.getSingleSelectedEntry();

				return !!entry && entry.type === 'file' && (entry.versions || 0) > 0;

			},
			// Открываем редактор текста для выделенного файла
			editSelection() {

				if (!this.canEditSelection()) return;

				this.openViewer(this.getSingleSelectedEntry(), 'edit');

			},
			// Показываем файл в отдельном окне (изображения, видео, звук, pdf, текст).
			// Аргументы события передаём массивом: Broadcast подписчику передаёт именно его
			openViewer(entry, mode = 'view') {

				if (!entry || entry.type !== 'file') return;

				Broadcast.call("Show FileViewer", [{
					publisherId: this.publisherId(),
					path: entry.path,
					name: entry.name,
					mode
				}]);

			},
			// Окно предыдущих версий файла
			openVersions() {

				let entry = this.getSingleSelectedEntry();

				if (!entry || entry.type !== 'file') return;

				this.versionsEntry = {paneIndex: this.getSelectionPaneIndex(), entry};
				this.versions = [];
				this.versionsError = '';
				this.versionsLoading = true;
				this.versionsShowed = true;

				FileService.requestVersions(this.publisherId(), entry.path);

			},
			closeVersions() {

				this.versionsShowed = false;
				this.versionsEntry = null;
				this.versions = [];
				this.versionsError = '';
				this.versionsLoading = false;

			},
			// Старая версия и текущий файл меняются местами
			restoreVersion(version) {

				if (!this.versionsEntry || !version) return;

				this.versionsError = '';
				this.versionsLoading = true;

				FileService.restoreVersion(this.publisherId(), this.versionsEntry.entry.path, version.id);

			},
			// Ошибки над списком файлов закрываются крестиком
			clearError() {

				this.errorMessage = '';

			},
			// ---- Публичные ссылки ----

			// Открываем окно публичных ссылок и запрашиваем их актуальный список
			openLinks() {

				this.linksShowed = true;
				this.links = FileService.getLinks(this.publisherId());

				FileService.requestLinks(this.publisherId());

			},
			// Создаём публичную ссылку на текущую открытую папку
			createLinkForActiveFolder() {

				FileService.createLink(this.publisherId(), this.getActivePath());

			},
			// Открываем публичную страницу по ссылке в новой вкладке
			openLink(link) {

				window.open(FileService.getLinkUrl(link), '_blank');

			},
			// Копируем адрес ссылки в буфер обмена
			copyLink(link) {

				if (this.copyToClipboard(FileService.getLinkUrl(link))) Notifications.showSuccess('Link copied to clipboard');

			},
			// Копируем произвольный текст в буфер обмена и возвращаем результат копирования
			// (работает и без Clipboard API, в т.ч. по http)
			copyToClipboard(text) {

				if (!text) return false;

				let input = document.createElement('textarea');

				input.value = text;
				input.style.position = 'fixed';
				input.style.opacity = '0';
				document.body.appendChild(input);
				input.select();

				let copied = false;

				try {

					copied = document.execCommand('copy');

				} catch (e) {}

				document.body.removeChild(input);

				return copied;

			},
			removeLink(link) {

				if (!confirm(`Delete public link to "${link.path}"?`)) return;

				FileService.deleteLink(this.publisherId(), link.id);

			},
			// Единственный выделенный объект в панели - повторный клик по нему снимает выделение
			isOnlySelectedEntry(paneIndex, entry) {

				let paths = this.getSelectedPaths(paneIndex);

				return paths.length === 1 && paths[0] === entry.path;

			},
			// Без Ctrl выделение возможно только в одной панели - вторую панель сбрасываем
			clearOtherPanesSelection(paneIndex) {

				_.each([0, 1], index => {

					if (index !== paneIndex && this.getSelectedPaths(index).length) this.clearSelection(index);

				});

			},
			// Есть ли у панели родительская папка: в корне выходить наверх некуда
			isInsideFolder(paneIndex) {

				return (this.panes[paneIndex] ? this.panes[paneIndex].path : '') !== '';

			},
			// Переходим в папку уровнем выше (точка ".." первой строкой списка файлов)
			openParent(paneIndex) {

				let currentPath = this.panes[paneIndex] ? this.panes[paneIndex].path : '';

				if (!currentPath) return;

				this.open(paneIndex, this.getParentPath(currentPath));

			},
			isParentDropTarget(paneIndex) {

				return this.dragOverParentPane === paneIndex;

			},
			// Точка ".." принимает только объекты менеджера: такой сброс переносит их на уровень вверх
			onParentDragOver(event, paneIndex) {

				if (this.getDragKind(event) !== 'entry') return;

				event.preventDefault();
				// Событие не должно дойти до панели, иначе подсветятся и панель, и точка ".."
				event.stopPropagation();

				event.dataTransfer.dropEffect = 'move';

				this.dragOverPane = paneIndex;
				this.dragOverEntry = null;
				this.dragOverParentPane = paneIndex;

			},
			onParentDragLeave(event, paneIndex) {

				event.stopPropagation();

				if (event.currentTarget && event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) return;

				if (this.dragOverParentPane === paneIndex) this.dragOverParentPane = null;

			},
			onParentDrop(event, paneIndex) {

				if (this.getDragKind(event) !== 'entry') return;

				event.preventDefault();
				event.stopPropagation();

				// Объект поднимается на уровень вверх относительно панели, в которой лежит точка ".."
				let parentPath = this.getParentPath(this.panes[paneIndex] ? this.panes[paneIndex].path : '');

				this.resetDragState();

				this.handleEntryDrop(parentPath);

			},
			// ---- Размер окна: запоминаем в localStorage и меняем драгом за правый нижний угол ----

			getWindowSizeStorageKey() {

				if (!User.currentUser) return null;

				return `files-window-size:${User.currentUser.id}`;

			},
			getDefaultWindowSize() {

				// По-умолчанию окно занимает почти всю ширину экрана и около 70% высоты
				return {
					width: Math.min(1600, Math.round(window.innerWidth * 0.9)),
					height: Math.round(window.innerHeight * 0.7)
				};

			},
			// Восстанавливаем размер окна из localStorage (при первом открытии - размер по-умолчанию)
			restoreWindowSize() {

				let size = this.getDefaultWindowSize();
				let key = this.getWindowSizeStorageKey();

				if (key) {

					try {

						let stored = JSON.parse(window.localStorage.getItem(key) || 'null');

						if (stored && stored.width) size.width = stored.width;
						if (stored && stored.height) size.height = stored.height;

					} catch (e) {}

				}

				this.windowWidth = size.width;
				this.windowHeight = size.height;

				this.clampWindowSize();

			},
			clampWindowSize() {

				let maxWidth = Math.max(window.innerWidth - 20, 480);
				let maxHeight = Math.max(window.innerHeight - 20, 260);

				this.windowWidth = Math.min(Math.max(this.windowWidth, 480), maxWidth);
				this.windowHeight = Math.min(Math.max(this.windowHeight, 260), maxHeight);

			},
			saveWindowSize() {

				let key = this.getWindowSizeStorageKey();

				if (!key) return;

				window.localStorage.setItem(key, JSON.stringify({width: Math.round(this.windowWidth), height: Math.round(this.windowHeight)}));

			},
			startWindowResize(event) {

				if (event.button !== 0) return;

				event.preventDefault();
				// Драг за угол не должен начинать выделение строк и перетаскивание окна
				event.stopPropagation();

				this.windowResizing = true;
				this.resizeProcess = {
					startX: event.clientX,
					startY: event.clientY,
					startWidth: this.windowWidth,
					startHeight: this.windowHeight
				};

				this.onWindowResizeMove = e => this.processWindowResize(e);
				this.onWindowResizeStop = () => this.stopWindowResize();

				document.addEventListener('mousemove', this.onWindowResizeMove);
				document.addEventListener('mouseup', this.onWindowResizeStop);

			},
			processWindowResize(event) {

				if (!this.resizeProcess) return;

				// Окно стоит по центру окна браузера, поэтому при изменении размера его края
				// расходятся в обе стороны: размер меняем вдвое быстрее курсора,
				// чтобы уголок, за который тянут, оставался под курсором
				this.windowWidth = this.resizeProcess.startWidth + 2 * (event.clientX - this.resizeProcess.startX);
				this.windowHeight = this.resizeProcess.startHeight + 2 * (event.clientY - this.resizeProcess.startY);

				this.clampWindowSize();

			},
			stopWindowResize() {

				if (!this.resizeProcess) return;

				document.removeEventListener('mousemove', this.onWindowResizeMove);
				document.removeEventListener('mouseup', this.onWindowResizeStop);

				this.resizeProcess = null;
				this.windowResizing = false;

				this.saveWindowSize();

			},
			formatSize(bytes) {

				bytes = bytes || 0;

				if (bytes < 1024) return `${bytes} B`;

				let units = ['KB', 'MB', 'GB', 'TB'];
				let value = bytes / 1024;
				let index = 0;

				while (value >= 1024 && index < units.length - 1) {

					value /= 1024;
					index++;

				}

				return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[index]}`;

			},
			formatDate(value) {

				if (!value) return '—';

				let date = value instanceof Date ? value : new Date(value);

				return date.toLocaleString();

			}
		},
		created() {

			this.restoreTwoPane();

		},
		// Клавиатура страницы: подписки снимаем при разрушении компонента
		mounted() {

			document.addEventListener('keydown', this.onDocumentKeyDown);

			// Размер окна готовим заранее: карточка не будет нулевой даже до первого показа
			this.restoreWindowSize();

		},
		beforeDestroy() {

			document.removeEventListener('keydown', this.onDocumentKeyDown);
			document.removeEventListener('mouseup', this.onDocumentMouseUp);

			// Снимаем слушатели ресайза окна, если он тянулся в момент разрушения
			this.stopWindowResize();

		}
	}
</script>


<style lang="sass" scoped>

	.files-window
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s
		color: #fff

		// Пока тянем угол окна - текст не выделяем
		&.window-resizing
			user-select: none

		.card
			position: relative
			display: flex
			flex-direction: column
			margin: auto
			// Ширина и высота приходят из компонента и запоминаются в localStorage
			max-width: 100%
			max-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.caption-area
				position: relative
				display: flex
				flex-direction: row
				flex-wrap: wrap
				align-items: center
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)
				padding: 0.5rem 2.5rem 0.5rem 1rem

				// Крестик закрытия окна файлов
				.window-close
					position: absolute
					right: 10px
					top: 10px
					background: none
					border: none
					color: #9da5b1
					cursor: pointer
					padding: 9px

					&:hover
						color: #fff

				.caption
					font-weight: bold
					margin-right: 20px

				.storage-info
					display: flex
					margin-right: auto
					color: #9da5b1

					.info-item
						margin-right: 15px

						b
							color: #fff

				.controls
					display: flex
					flex-direction: row
					align-items: center

					.folder-name
						width: 170px
						margin-right: 8px

					button
						margin-left: 8px

						&:first-child
							margin-left: 0

						// Upload files и Public links отделяются от соседних кнопок отступом 20px
						&.gap
							margin-left: 20px

					// Отступ перед кнопкой Log
					.log-button
						margin-left: 20px
						margin-right: 10px

					.two-pane-toggle
						display: flex
						align-items: center
						// Отступ перед переключателем Two-pane
						margin-left: 15px
						margin-right: 0

						& > span
							margin-right: 8px
							user-select: none

						label.switch
							display: inline-block
							margin-bottom: 0
							margin-top: 3px

			.upload-progress
				padding: 0 1rem

				.progress
					height: 5px
					margin: 8px 0

			.error-message
				display: flex
				flex-direction: row
				align-items: flex-start
				justify-content: space-between
				padding: 8px 1rem
				color: #f86c6b

				.message-text
					flex: 1

				// Крестик, которым закрывается сообщение об ошибке
				.error-close
					padding: 0 0 0 10px
					background: none
					border: none
					color: inherit
					cursor: pointer

					&:hover
						color: #fff

			.panes
				display: flex
				flex-direction: column
				// Область файлов занимает всё место окна фиксированной высоты, а панели скроллятся сами
				flex: 1 1 auto
				min-height: 0
				overflow: hidden

				&.two-pane
					flex-direction: row
					align-items: stretch

					.pane
						width: 50%

				.pane
					display: flex
					flex-direction: column
					// Панель полностью занимает высоту области файлов, поэтому список скроллится внутри неё
					flex: 1
					width: 100%
					min-height: 0
					overflow: hidden
					border-right: 1px solid rgba(0, 0, 0, 0.3)

					&.active
						outline: 1px solid rgba(77, 189, 116, 0.6)
						outline-offset: -1px

					// Подсветка панели, когда над ней перетаскивают файлы из ОС или объект из другой панели
					&.drop-target
						background-color: rgba(91, 255, 148, 0.05)
						outline: 2px dashed rgba(91, 255, 148, 0.8)
						outline-offset: -2px

					.breadcrumbs
						display: flex
						flex-wrap: wrap
						align-items: center
						padding: 0.4rem 1rem
						background-color: #343b41
						border-bottom: 1px solid rgba(0, 0, 0, 0.3)

						.crumb
							cursor: pointer
							color: #5bff94

							&:hover
								text-decoration: underline

						.crumb-sep
							margin: 0 5px
							color: #73818f

					.entries
						// Список файлов прокручивается внутри области фиксированной высоты
						flex: 1
						min-height: 0
						overflow-y: auto

						// Точка ".." первой строкой списка: выход на уровень вверх, сюда же переносят файлы
						.parent-entry
							display: flex
							align-items: center
							padding: 0.35rem 1rem
							border-bottom: 1px solid rgba(255, 255, 255, 0.05)
							color: #9da5b1
							cursor: pointer
							user-select: none

							&:hover
								background-color: rgba(255, 255, 255, 0.04)

							&.drop-target
								background-color: rgba(91, 255, 148, 0.18)
								outline: 1px solid rgba(91, 255, 148, 0.8)
								outline-offset: -1px

							i.fa
								width: 16px
								margin-right: 8px
								color: #f0b400

							.parent-name
								font-weight: bold

						.entry
							display: flex
							align-items: center
							padding: 0.35rem 1rem
							border-bottom: 1px solid rgba(255, 255, 255, 0.05)

							&:hover
								background-color: rgba(255, 255, 255, 0.04)

							// Подсветка папки, когда над ней перетаскивают файлы / объект для переноса внутрь
							&.drop-target
								background-color: rgba(91, 255, 148, 0.18)
								outline: 1px solid rgba(91, 255, 148, 0.8)
								outline-offset: -1px

							// Строку выделяют кликом, Ctrl / Shift + кликом, протяжкой мыши и стрелками клавиатуры
							cursor: pointer
							user-select: none

							&.selected
								background-color: rgba(91, 255, 148, 0.14)

								&:hover
									background-color: rgba(91, 255, 148, 0.2)

							// Курсор клавиатурной навигации
							&.cursor
								outline: 1px solid rgba(91, 255, 148, 0.8)
								outline-offset: -1px

							.col
								&.name
									// Названию файла отдаём всё свободное место, длинные имена обрезаются многоточием
									flex: 1
									min-width: 0
									display: flex
									align-items: center

									.entry-name
										white-space: nowrap
										overflow: hidden
										text-overflow: ellipsis

									// Значок того, что у файла есть предыдущие версии
									i.fa.versions-hint
										width: auto
										margin-left: 6px
										margin-right: 0
										color: #9da5b1
										font-size: 12px
									// Клик по строке выделяет объект, двойной клик по папке открывает её,
								// а скачивание и остальные действия выполняются кнопками внизу страницы

								i.fa
									width: 16px
									margin-right: 8px
									color: #f0b400

									// Ручка перетаскивания объекта в папку или во вторую панель
									&.entry-drag-handle
										color: #73818f
										cursor: move
										opacity: 0.45

										&:hover
											opacity: 1

								&.size
									// Название файла занимает свободное место, а размер и дата прижаты вправо
									width: 130px
									text-align: right
									color: #9da5b1
									font-size: 12px

								&.date
									width: 190px
									text-align: right
									color: #9da5b1
									font-size: 12px

								&.actions
									width: 60px
									display: flex
									justify-content: flex-end

									.action
										background: none
										border: none
										color: #9da5b1
										cursor: pointer
										padding: 2px 5px

										&:hover
											color: #fff

										&.danger:hover
											color: #f86c6b

							.permissions
								display: flex
								align-items: center
								margin-left: 8px

								.avatar
									width: 20px
									height: 20px
									border-radius: 50%
									margin-left: -5px
									border: 1px solid #3a4149

					.empty
						padding: 1rem
						color: #73818f

			// Действия с выделенными объектами: панель всегда видна внизу страницы, даже если файлов больше экрана
			.actions-bar
				position: sticky
				bottom: 0
				z-index: 10
				display: flex
				flex-direction: row
				flex-wrap: wrap
				align-items: center
				// Короткий список - панель всё равно остаётся внизу страницы
				margin-top: auto
				padding: 0.5rem 1rem
				background-color: #343b41
				border-top: 1px solid rgba(0, 0, 0, 0.3)

				.selection-info
					margin-right: auto
					color: #9da5b1
					font-size: 12px

				.actions-buttons
					display: flex
					flex-direction: row
					flex-wrap: wrap
					align-items: center

					// Отступ между кнопками
					button
						margin-left: 8px

			// Уголок, за который окно тянется по ширине и высоте
			.resize-handle
				position: absolute
				right: 0
				bottom: 0
				width: 18px
				height: 18px
				z-index: 10
				cursor: nwse-resize

				&:hover
					background: linear-gradient(135deg, transparent 50%, rgba(91, 255, 148, 0.6) 50%)

			.rename-overlay, .permissions-overlay, .new-folder-overlay, .key-overlay, .links-overlay, .versions-overlay, .search-overlay
				position: fixed
				left: 0
				top: 0
				right: 0
				bottom: 0
				background-color: rgba(0, 0, 0, 0.6)
				display: flex
				z-index: 2000

				.overlay-card
					width: 460px
					max-height: 70vh
					overflow: auto
					margin: auto
					padding: 1rem
					background-color: #3a4149
					border-radius: 4px
					box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

					label
						display: block
						margin-bottom: 0.5rem

					.description
						color: #9da5b1
						font-size: 12px
						margin-bottom: 10px

					.users-list
						max-height: 45vh
						overflow: auto
						margin-bottom: 10px

						.user-row
							display: flex
							align-items: center
							padding: 3px 0

							label
								display: flex
								align-items: center
								margin: 0
								cursor: pointer
								margin-left: 1.25rem

								.form-check-input
									margin-top: 0 !important

							.avatar
								width: 24px
								height: 24px
								border-radius: 50%
								margin: 0 8px

							.user-activity
								color: #9da5b1
								font-size: 12px
								margin-left: 10px

					.overlay-actions
						display: flex
						justify-content: flex-end
						margin-top: 10px

						button
							margin-left: 8px

			// Окно списка предыдущих версий файла
			.versions-overlay

				.versions-list
					max-height: 45vh
					overflow: auto
					margin-bottom: 10px
					border: 1px solid #23282c
					border-radius: 4px

					.version-row
						display: flex
						flex-direction: row
						align-items: center
						padding: 6px 8px
						background-color: #343b41
						border-bottom: 1px solid rgba(0, 0, 0, 0.2)

						.version-date
							flex: 1
							font-size: 13px

						.version-size
							width: 90px
							text-align: right
							color: #9da5b1
							font-size: 12px

						.version-restore
							width: 100px
							text-align: right

				.versions-loading, .empty-versions
					padding: 8px 0
					color: #9da5b1
					font-size: 13px

			.links-overlay .links-card
				width: 620px

				.empty-links
					padding: 8px 0
					color: #9da5b1
					font-size: 13px

				.existing-links-container
					max-height: 40vh
					overflow: auto
					border: 1px solid #23282c
					border-radius: 4px

					.existing-links
						display: table
						width: 100%
						background-color: #343b41

						.existing-link
							display: table-row
							color: #9da5b1

							&:hover
								background-color: #4c4f54

							>div
								display: table-cell
								padding: 5px 8px
								vertical-align: middle

							.link-date
								width: 150px
								font-size: 12px

							.link-url
								a
									color: #5bff94
									text-decoration: none

									&:hover
										text-decoration: underline

								.link-path
									display: block
									color: #73818f
									font-size: 11px

							.link-type
								width: 60px
								text-align: center
								font-size: 12px

							.link-actions
								width: 100px
								text-align: right
								white-space: nowrap

								.action
									background: none
									border: none
									color: #9da5b1
									cursor: pointer
									padding: 2px 5px

									&:hover
										color: #fff

									&.danger:hover
										color: #f86c6b

			.search-overlay

				.search-card
					width: 720px

					.search-input-row
						display: flex
						flex-direction: row
						align-items: center
						margin-bottom: 10px

						i
							width: 30px
							text-align: center
							color: #9da5b1

						input
							flex: 1
							margin-right: 8px

					.search-loading, .empty-results
						padding: 8px 0
						color: #9da5b1
						font-size: 13px

					.search-error
						margin-bottom: 6px

					.search-results
						max-height: 45vh
						overflow: auto
						border: 1px solid #23282c
						border-radius: 4px

						.search-result
							display: flex
							flex-direction: row
							align-items: center
							padding: 6px 8px
							background-color: #343b41
							border-bottom: 1px solid rgba(0, 0, 0, 0.2)
							cursor: pointer

							&:hover
								background-color: #4c4f54

							>i
								width: 20px
								text-align: center
								color: #9da5b1

							.result-name
								flex: 1
								margin-left: 8px
								overflow: hidden
								text-overflow: ellipsis
								white-space: nowrap

							.result-path
								width: 45%
								color: #73818f
								font-size: 12px
								overflow: hidden
								text-overflow: ellipsis
								white-space: nowrap

							.result-size
								width: 90px
								text-align: right
								color: #9da5b1
								font-size: 12px

							.result-date
								width: 150px
								text-align: right
								color: #9da5b1
								font-size: 12px
</style>

